/**
 * Scheduled Content Manager - Web Component
 */

class ScheduledContentManager extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
    this.updateInterval = 60000;
    this.selectors = {
      scheduledSection: '[data-scheduled-content]',
      activationStartAttr: 'data-activation-start',
      activationEndAttr: 'data-activation-end',
      scheduledSectionClass: '.scheduled-section'
    };
  }
 
  connectedCallback() {
    this.initScheduledContent();
  }
 
  disconnectedCallback() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
 
  /**
   * Makes a section visible by resetting its display style
   * @param {HTMLElement} section - The section element to show
   */
  showSection(section) {
    section.style.display = '';
  }
 
  /**
   * Hides a section by setting its display style to 'none'
   * @param {HTMLElement} section - The section element to hide
   */
  hideSection(section) {
    section.style.display = 'none';
  }
 
  /**
   * Updates the visibility of each scheduled section based on its activation start and end times
   * @param {NodeList} scheduledSections - Collection of section elements to check and update
   */
  updateSectionVisibility(scheduledSections) {
    const now = new Date();
    const nowUnix = Math.floor(now.getTime() / 1000);
   
    scheduledSections.forEach((section) => {
      let shouldShow = true;
      const startTimeStr = section.getAttribute(this.selectors.activationStartAttr);
      const endTimeStr = section.getAttribute(this.selectors.activationEndAttr);
     
      if (!startTimeStr && !endTimeStr) {
        this.showSection(section);
        return;
      }
      
      if (startTimeStr && startTimeStr.trim() !== '') {
        try {
          const startDate = new Date(startTimeStr);
          const startTime = Math.floor(startDate.getTime() / 1000);
          if (startTime > nowUnix) {
            shouldShow = false;
          }
        } catch (error) {
          console.warn(`Error parsing start time: ${startTimeStr}`, error);
        }
      }
     
      if (endTimeStr && endTimeStr.trim() !== '') {
        try {
          const endDate = new Date(endTimeStr);
          const endTime = Math.floor(endDate.getTime() / 1000);
          if (endTime < nowUnix) {
            shouldShow = false;
          }
        } catch (error) {
          console.warn(`Error parsing end time: ${endTimeStr}`, error);
        }
      }
      if (shouldShow) {
        this.showSection(section);
      } else {
        this.hideSection(section);
      }
    });
  }
 
  /**
   * Initializes the scheduled content functionality by finding all scheduled sections,
   * updating their initial visibility, and setting up an interval to check periodically
   */
  initScheduledContent() {
    const scheduledSections = document.querySelectorAll(
      `${this.selectors.scheduledSectionClass}${this.selectors.scheduledSection}, ${this.selectors.scheduledSection}`
    );
   
    if (!scheduledSections.length) {
      return;
    }
   
    this.updateSectionVisibility(scheduledSections);
   
    this.intervalId = setInterval(() => {
      this.updateSectionVisibility(scheduledSections);
    }, this.updateInterval);
  }
}
 
customElements.define('scheduled-content-manager', ScheduledContentManager);